var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-title',[_vm._v("Projekt vorschlagen")]),_c('c-project-form',{on:{"submit":_vm.submit,"validation":function($event){_vm.validationStatus = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }